<template>
  <!-- <transition name="slide-top">
    <cube-popup
      v-show="isVisible"
      ref="myPopup"
      type="my-popup"
      :center="false"
      position="top"
      class="repeat-filter-wrap"
      @mask-click="maskClick"
    > -->
  <div
    v-show="isVisible"
    class="repeat-list"
  >
    <cube-input
      v-model="form.value"
      :placeholder="form.placeholder"
      :clearable="true"
      @input="handleInput"
    >
      <template slot="prepend">
        <i class="iconfont iconicon-test29" />
      </template>
      <template slot="append">
        <span
          class="text-btn"
          @click="handleReset"
        >{{ $t('message["896"]') }}</span>
      </template>
    </cube-input>
    <div
      v-if="form.value"
      class="list-box"
    >
      <template
        v-if="!loading"
      >
        <load-more
          v-if="mList && mList.length"
          class="wrapper"
          :data="mList"
          :page="pagination.currentPage"
          :total="pagination.total"
          :limit="pagination.pageSize"
          more-text=" "
          @loadData="onSearch"
        >
          <template>
            <ul
              class="list"
            >
              <li
                v-for="(item, index) in mList"
                :key="item.inquiryid"
                class="border-bottom-1px"
                @click="handlerDetail(item)"
              >
                <my-item
                  :data="item"
                  :index="index"
                />
              </li>
            </ul>
          </template>
        </load-more>
        <div
          v-show="searched && (!newList || !newList.length)"
          class="empty-box blank wrapper"
        >
          <img
            src="@/assets/images/blank.png"
            :alt="altTip"
          >
          <p class="placeholder">
            {{ $t('message["93"]') }}
          </p>
          <a-button
            type="primary"
            class="cube-btn-primary"
            @click="onClickAdd"
          >
            {{ $t('message["622"]') }}
          </a-button>
        </div>
      </template>
      <cube-loading
        v-else
        :size="24"
      />
    </div>
  </div>
  <!--  </cube-popup>
  </transition> -->
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { getEncode } from '@/lib/mix'
import { setCodeData } from '@/lib/utils'
// import BScroll from 'better-scroll'
import LoadMore from '@/components/mobile/LoadMore.vue'
import Item from './Item.vue'
import _ from 'lodash'

export default {
  components: {
    LoadMore,
    MyItem: Item
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    checkrepeatfieldkey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // timer: null,
      isVisible: false,
      inquiryCheckRepeatView: false
    }
  },
  computed: {
    ...mapState('inquery/repeatData', [
      'loading',
      'searched',
      'titles',
      'list',
      'pagination',
      'searchConfig'
    ]),
    ...mapGetters('inquery/repeatData', [
      'newList',
      'columns'
    ]),
    pid () {
      return this.$route.params.pid
    },
    form () {
      return this.searchConfig
    },
    mList () {
      let data = _.cloneDeep(this.list)
      for (let item of data) {
        for (let fieldkey in item) {
          let column = item[fieldkey]
          item.list = item.list || {}

          if (fieldkey === 'code' || fieldkey === 'inquiryid') continue
          let obj = {}
          if (_.isPlainObject(column)) {
            obj = item[fieldkey]
          } else if (_.isString(column)) {
            obj.fieldvalue = column || ''
          }
          obj.fieldkey = fieldkey
          for (let k in this.titles) {
            if (k === fieldkey) {
              obj.title = this.titles[k]
              item.list[fieldkey] = obj
            }
          }
        }
      }
      return data
    },
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    },
    altTip () {
      return this.$t('message["1553"]')
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
    },
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize

      this.onSearch()
    }
  },
  created () {
    this.form.value = ''
    this.clearList()
  },

  methods: {
    ...mapActions('inquery/repeatData', ['fetchList', 'setSearchConfig', 'clearList']),
    async getRepeatList (params) {
      if (params.fieldvalue) {
        const enCode = await getEncode()
        params.fieldvalue = await setCodeData(params.fieldvalue, enCode)
      }
      const chain = await this.fetchList()
      chain
        .params({
          ...params,
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          device: 1
          // device: 2 // 代表 mobile
        })
        .onSuccess((res, raw) => {
          const { permissions = {} } = raw
          this.inquiryCheckRepeatView = permissions['inquiry-check-repeat-view']
        })
        .fetch()
    },
    handleInput (val) {
      this.clearList()
      this.setSearchConfig(this.form)
      this.$router.push({
        query: { page: 1 }
      })
      if (val === '') return

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.onSearch()
      }, 60)
    },
    onClickAdd () {
      this.$router.push({
        name: 'InqueryCreate',
        query: {
          checkrepeatfieldkey: this.checkrepeatfieldkey,
          checkrepeatfieldvalue: this.form.value
        }
      })
    },
    onSearch () {
      let params = {}
      params.fieldkey = this.form.key
      params.fieldvalue = this.form.value
      this.getRepeatList(params)
    },
    handleReset () {
      this.hide()
      this.form.value = ''
      this.form.key = this.searchConfig.options[0].fieldkey
      this.form.placeholder = `${this.$t('message["751"]')} ${this.form.options[0].fieldname}`
      this.clearList()

      this.$forceUpdate()
    },
    /* setContent (item = {}) {
      let data = {}
      let currentKey = ''

      const keys = this.titles && Object.keys(this.titles)
      for (let key of keys) {
        if (key.indexOf(this.form.key)) {
          currentKey = key
        }
      }
      const currentItem = item[currentKey] || {}
      if (this.form.key === 'company_name') {
        data.top = ''
      } else if (this.$toType(currentItem.fieldvalue) === 'array') {
        data.top = currentItem.fieldvalue.join(',')
      } else {
        data.top = currentItem.fieldvalue
      }

      let companyObj = item['contact_info_company_name'] || {}
      data.content = companyObj.fieldvalue

      return data
    }, */
    handlerDetail (item) {
      if (!this.inquiryCheckRepeatView) {
        this.$selefToast({ type: 'error', text: this.$t('message["160"]') })
        return
      }

      this.$router.push({
        path: `/project/${this.pid}/inquery/detail/${item.inquiryid}`,
        query: {
          ...this.$route.query,
          from: 'checkrepeat',
          checkrepeatfieldkey: this.checkrepeatfieldkey
        }
      })
    },
    hide () {
      this.$emit('update:visible', false)
    },
    maskClick () {
      this.handleReset()
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-top-enter,
.slide-top-leave-active {
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}

.slide-top-enter-active,
.slide-top-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

::v-deep.cube-input_active:after {
  border: none !important;
}
.cube-input ::v-deep {
  padding: 8px;
  background-color: #f1f1f1;
  .cube-input-prepend {
    position: absolute;
    left: 13px;
    color: #999;
  }
  .cube-input-field {
    margin-right: 8px;
    padding: 7px 10px 7px 30px;
    background-color: #fff;
    border-radius: 4px;
  }
  .cube-input-append {
    color: $primary-color;
  }
}
.wrapper {
  width: 100%;
  height: calc(100vh - 60px);
  overflow: hidden;
}
.empty-box {
  padding-top: 26px;
  text-align: center;
  background: #fff;
  img {
    width: 150px;
  }
  .placeholder {
    margin-top: 42px;
    color: $gray3;
    font-size: 16px;
  }
  .cube-btn-primary {
    width: 200px;
    height: 46px;
    margin-top: 32px;
    font-size: 18px;
  }
}
</style>
